import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface ActiveUntilTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const InvoiceAmountTooltip: React.FC<ActiveUntilTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        <Trns source={'Enter the total amount due as shown on the invoice'} />
      </p>
    </Tooltip>
  )
}

export default InvoiceAmountTooltip
